<template>
  <div class="home_page">
    <Head class="head_box"></Head>
    <div class="login_box">
      <div class="logo">
        <img src="../assets/img/fhlogo.png" class="img" />
      </div>
      <el-form
        :inline="true"
        :model="loginForm"
        class="form_box"
        v-if="!$store.state.userInfo"
      >
        <el-form-item label="账号" class="form_item">
          <el-input
            v-model="loginForm.username"
            placeholder="手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" class="form_item">
          <el-input
            type="password"
            v-model="loginForm.password"
            autocomplete="off"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            style="background: #00a0e9; border-color: #00a0e9"
            @click="toLogin"
            >登录</el-button
          >
          <el-button @click="toRegister">立即注册</el-button>
          <el-button type="text" @click="toSetPassward">重置密码</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="banner_box">
      <div class="menu_box">
        <el-menu
          class="el-menu-vertical-demo"
          popper-append-to-body
          :unique-opened="true"
          @select="toSelectMenu"
        >
          <el-submenu index="1" class="menu_item" v-if="$store.state.userInfo">
            <template slot="title">
              <span>报价下单</span>
            </template>
            <el-menu-item index="1-3" class="menu_item">卷装不干胶</el-menu-item>
            <el-menu-item index="1-2" class="menu_item">专版不干胶</el-menu-item>
            <el-menu-item index="1-5" class="menu_item">数码不干胶</el-menu-item>
            <el-menu-item index="1-4" class="menu_item">特殊卷标</el-menu-item>
            <el-menu-item index="1-1" class="menu_item">合版不干胶</el-menu-item>
          </el-submenu>
          <el-submenu index="6" class="menu_item" v-if="$store.state.userInfo">
            <template slot="title">
              <span>我的订单</span>
            </template>
            <el-menu-item index="6-1" class="menu_item">管理中心</el-menu-item>
            <el-menu-item index="6-2" class="menu_item">订单管理</el-menu-item>
            <el-menu-item index="6-3" class="menu_item">财务明细</el-menu-item>
            <el-menu-item index="6-4" class="menu_item">会员信息</el-menu-item>
            <el-menu-item index="6-5" class="menu_item"
              >授权书管理</el-menu-item
            >
            <el-menu-item index="6-6" class="menu_item"
              >发票抬头管理</el-menu-item
            >
            <!-- <el-menu-item index="6-7" class="menu_item">发票管理</el-menu-item> -->
            <el-menu-item index="6-8" class="menu_item">修改密码</el-menu-item>
            <el-menu-item index="6-9" class="menu_item">预存</el-menu-item>
            <el-menu-item index="6-0" class="menu_item">售后记录</el-menu-item>
            <el-menu-item index="6-11" class="menu_item">领券中心</el-menu-item>
            <el-menu-item index="6-12" class="menu_item"
              >我的优惠券</el-menu-item
            >
          </el-submenu>
          <el-menu-item index="2" class="menu_item">
            <span slot="title">下单必读</span>
          </el-menu-item>
          <el-menu-item index="3" class="menu_item">
            <span slot="title">操作指引</span>
          </el-menu-item>
          <el-menu-item index="4" class="menu_item">
            <span slot="title">联系方式</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="menu_h5_box" v-if="showMenu">
        <el-menu
          class="el-menu-vertical-demo"
          mode="horizontal"
          background-color="#00a0e9"
          text-color="#FFFFFF"
          popper-append-to-body
          :unique-opened="true"
          @select="toSelectMenu"
        >
          <el-submenu
            index="1"
            class="menu_item"
            popper-append-to-body
            v-if="$store.state.userInfo"
          >
            <template slot="title">
              <span>报价下单</span>
            </template>
            <el-menu-item index="1-3" class="menu_item">卷装不干胶</el-menu-item>
            <el-menu-item index="1-2" class="menu_item">专版不干胶</el-menu-item>
            <el-menu-item index="1-5" class="menu_item">数码不干胶</el-menu-item>
            <el-menu-item index="1-4" class="menu_item">特殊卷标</el-menu-item>
            <el-menu-item index="1-1" class="menu_item">合版不干胶</el-menu-item>
          </el-submenu>
          <el-submenu
            index="6"
            class="menu_item"
            popper-append-to-body
            v-if="$store.state.userInfo"
          >
            <template slot="title">
              <span>我的订单</span>
            </template>
            <el-menu-item index="6-1" class="menu_item">管理中心</el-menu-item>
            <el-menu-item index="6-2" class="menu_item">订单管理</el-menu-item>
            <el-menu-item index="6-3" class="menu_item">财务明细</el-menu-item>
            <el-menu-item index="6-4" class="menu_item">会员信息</el-menu-item>
            <el-menu-item index="6-5" class="menu_item"
              >授权书管理</el-menu-item
            >
            <el-menu-item index="6-6" class="menu_item"
              >发票抬头管理</el-menu-item
            >
            <!-- <el-menu-item index="6-7" class="menu_item">发票管理</el-menu-item> -->
            <el-menu-item index="6-8" class="menu_item">修改密码</el-menu-item>
            <el-menu-item index="6-9" class="menu_item">预存</el-menu-item>
            <el-menu-item index="6-0" class="menu_item">售后记录</el-menu-item>
            <el-menu-item index="6-11" class="menu_item">领券中心</el-menu-item>
            <el-menu-item index="6-12" class="menu_item"
              >我的优惠券</el-menu-item
            >
          </el-submenu>
          <el-menu-item index="2" class="menu_item_h5">
            <span slot="title">下单必读</span>
          </el-menu-item>
          <el-menu-item index="4" class="menu_item_h5">
            <span slot="title">联系方式</span>
          </el-menu-item>
        </el-menu>
      </div>
      <el-carousel height="600px" id="banner" :interval="4000">
        <el-carousel-item v-for="item in bannerList" :key="item.bannerId">
          <img
            :src="item.bannerImageUrl"
            alt=""
            style="object-fit: fill; height: 600px; width: 100%"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="content">
      <div
        class="view"
        v-for="(item, index) of homeimageList"
        :key="index"
        :style="{ background: item.imageBackColor }"
      >
        <div class="vi_top">
          <div class="vi_top_name">{{ item.title }}</div>
          <div class="vi_top_text">{{ item.imageDesc }}</div>
        </div>
        <div class="vi_down">
          <img :src="item.imageUrl" class="vi_down_img" loading="lazy" />
        </div>
      </div>
    </div>
    <div class="contentTwo">
      <div class="view">
        <img src="../assets/img/下载.png" class="icon" loading="lazy" />
        <div class="name">专业推荐</div>
        <div class="contenItem">专业人员咨询推荐</div>
      </div>
      <div class="view">
        <img src="../assets/img/下载 (1).png" class="icon" loading="lazy" />
        <div class="name">全国物流</div>
        <div class="contenItem">大物物流小物快递</div>
      </div>
      <div class="view">
        <img src="../assets/img/下载 (2).png" class="icon" loading="lazy" />
        <div class="name">优质印刷</div>
        <div class="contenItem">二十多年印刷经验</div>
      </div>
      <div class="view">
        <img src="../assets/img/下载 (3).png" class="icon" loading="lazy" />
        <div class="name">售后无忧</div>
        <div class="contenItem">订单问题负责到底</div>
      </div>
      <div class="view">
        <img src="../assets/img/下载 (4).png" class="icon" loading="lazy" />
        <div class="name">急速生产</div>
        <div class="contenItem">最快24小时出货</div>
      </div>
    </div>
    <Bottom></Bottom>
    <floatButton></floatButton>
  </div>
</template>

<script>
import { loginApi, getHomeInfoApi, repasswordApi, personalInfoApi } from "../api/index";
export default {
  name: "Home",
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
      },
      bannerList: [],
      homeimageList: [],
      showMenu: true,
      form: {
        phone: "",
      }
    };

  },
  created() {
    this.showMenu = true;
  },
  activated() {
    this.showMenu = true;
    this.getInfo();
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      if(!this.$store.state.userInfo) {
        return
      }
      personalInfoApi()
        .then((res) => {
          if (res.resultStatus) {
            const result = res.resultData;
            this.form.phone = result.phone ? result.phone : "";
          } else {
            this.form.phone = "";
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    toLogin() {
      if (!this.loginForm.username) {
        this.$message("请输入会员号/手机号");
        return;
      }
      if (!this.loginForm.password) {
        this.$message("请输入密码");
        return;
      }
      loginApi({
        phone: this.loginForm.username,
        password: this.loginForm.password,
      })
        .then((res) => {
          if (res.resultStatus) {
            this.$message.success('登录成功')
            localStorage.removeItem('customOrders');
            window.localStorage.setItem("yinyi_token", res.resultData.userIdStr || String(res.resultData.userId));
            this.$store.commit("UPDATE_USER_INFO", {
              companyName: res.resultData.companyName,
              userId: res.resultData.userId,
              userIdStr: res.resultData.userIdStr,
            });
            this.$store.commit("UPDATE_ACTIVE_MENU", '1-3');
            this.$router.push({
              name: "orderPage",
            });
          } else {
            this.$message.warning(res.errorMessage)
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toRegister() {
      this.$router.replace({
        name: "register",
      });
    },
    toSetPassward() {
      // if (!this.loginForm.username) {
      //   this.$message.warning("请输入手机号或者邮箱");
      //   return;
      // }
      // repasswordApi({
      //   phoneOrEmail: this.loginForm.username,
      // }).then((res) => {
      //   if (res.resultStatus) {
      //     this.$message.success("请留意您的手机短信或邮箱信息");
      //   } else {
      //     this.$message.warning(res.errorMessage);
      //   }
      // });
      this.$router.replace({
        name: "forget",
      });
    },
    toHome() {
      this.$router.replace({
        name: "Home",
      });
    },
    toSelectMenu(index, indexPath) {
      this.$store.commit("UPDATE_ACTIVE_MENU", null);
      switch (index) {
        case "1-1":
        case "1-2":
        case "1-3":
        case "1-4":
        case "1-5":
          this.$router.push({
            name: "orderPage",
          });
          break;
        case "6-1":
          this.$router.push({
            name: "manegeCenter",
          });
          break;
        case "6-2":
          this.$router.push({
            name: "orderManege",
          });
          break;
        case "6-3":
          this.$router.push({
            name: "financeDetails",
          });
          break;
        case "6-4":
          this.$router.push({
            name: "personalInfo",
          });
          break;
        case "6-5":
          this.$router.push({
            name: "authentication",
          });
          break;
        case "6-6":
          this.$router.push({
            name: "invoiceTitle",
          });
          break;
        case "6-7":
          this.$router.push({
            name: "InvoiceManagement",
          });
          break;
        case "6-8":
          this.$router.push({
            name: "modifyPass",
          });
          break;
        case "6-9":
          this.$router.push({
            name: "prestorage",
          });
          break;
        case "6-0":
          this.$router.push({
            name: "after_sales_reasons",
          });
          break;
        case "6-11":
          this.$router.push({
            name: "couponList",
          });
          break;
        case "6-12":
          this.$router.push({
            name: "myCoupon",
          });
          break;
        case "2":
          this.$router.push({
            name: "orderDocument",
          });
          break;
        case "3":
          this.$router.push({
            name: "Operations",
          });
          break;
        case "4":
          this.$router.push({
            name: "contactWay",
          });
          break;
        default:
          break;
      }
      this.showMenu = false;
      this.$store.commit("UPDATE_ACTIVE_MENU", index);
    },
    getInfo() {
      getHomeInfoApi()
        .then((res) => {
          if (res.resultStatus) {
            const fullBannerList = res.resultData.bannerList || [];
            // 先只显示第一张图片
            this.bannerList = fullBannerList.length > 0 ? [fullBannerList[0]] : [];
            // 3秒后显示全部图片
            setTimeout(() => {
              this.bannerList = fullBannerList;
            }, 4000);
            this.homeimageList = res.resultData.homeimageList || [];
          } else {
            this.bannerList = [];
            this.homeimageList = [];
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.home_page {
  width: 100%;
  height: 100%;
  overflow: scroll;
  position: absolute;
  padding-top: 30px;
  &::-webkit-scrollbar {
    width: 0.1rem;
    background-color: rgba(0, 0, 0, 0);
  }

  &::-webkit-scrollbar-thumb {
    background-color: #d4d4d4;
  }
  .head_box {
    position: fixed;
    top: 0;
  }
  .customer_icon {
    position: fixed;
    top: 50%;
    right: 0;
    z-index: 100;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 40px;
      height: 40px;
    }
  }
  /* 支付按钮样式 */
.pay_button_box {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
  background-color: #f5f5f5;
}

@media screen and (min-width: 480px) {
    .login_box {
      margin: 10px 72px;
      display: flex;
      align-items: center;
      .logo {
        width: 200px;
        height: 80px;
        display: flex;
        align-items: center;
      }
      .img {
        width: 160px;
        cursor: pointer;
      }
    }
    .form_box {
      display: flex;
      align-items: center;
      margin-left: 20px;
      flex-wrap: wrap;
    }
    .banner_box {
      position: relative;
      .menu_box {
        width: 200px;
        height: 100%;
        background: #00a0e9;
        padding: 0;
        position: absolute;
        left: 200px;
        z-index: 10;
        overflow-y: scroll;
        overflow-x: hidden;
        &::-webkit-scrollbar {
          width: 0.1rem;
          background-color: rgba(0, 0, 0, 0);
        }

        &::-webkit-scrollbar-thumb {
          background-color: #d4d4d4;
        }
      }
      .menu_h5_box {
        display: none;
      }
    }
    .content {
      width: 100%;
      box-sizing: border-box;
      padding: 30px 0;
      display: flex;
      justify-content: center;
      .view {
        width: 260px;
        height: 340px;
        margin: 0 60px;
        display: inline-flex;
        flex-direction: column;
        justify-content: space-between;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        cursor: pointer;
      }
      .vi_top {
        text-align: center;
        margin-top: 20px;
        .vi_top_name {
          font-size: 24px;
          color: #353535;
          font-weight: 700;
          letter-spacing: 1.6px;
        }
        .vi_top_text {
          font-size: 14px;
          color: #888;
          margin-top: 6px;
        }
      }
      .vi_down {
        width: 100%;
        height: 260px;
        margin-bottom: 0;
        overflow: hidden;
        position: relative;
        .vi_down_img {
          width: 100%;
          height: 240px;
          transition: transform 0.2s;
          position: absolute;
          bottom: 0;
          left: 0;
          will-change: transform;
        }
        .vi_down_img:hover {
          transform: translateY(-10px);
        }
      }
    }
    .contentTwo {
      background: #fff;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 48px 0;
      margin: 0 72px 120px 72px;
      .view {
        width: 240px;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        border-right: 1px dotted #eee;
        position: relative;
        .icon {
          width: 62px;
          height: 62px;
        }
        .name {
          font-size: 18px;
          color: #333;
        }
        .contenItem {
          font-size: 14px;
          color: #999;
        }
      }
    }
  }
  @media only screen and (max-width: 480px) {
    .login_box {
      margin-top: 10px;
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .logo {
        width: 200px;
        height: 80px;
        margin-left: 20px;
        display: flex;
        align-items: center;
      }
      .img {
        width: 160px;
        cursor: pointer;
      }
      .form_item {
        margin-bottom: 10px;
      }
    }
    .form_box {
      display: flex;
      margin-left: 20px;
      flex-wrap: wrap;
    }
    .banner_box {
      background: #00a0e9;
      /deep/.el-menu-vertical-demo {
        display: flex;
        background: #00a0e9;
      }
      .menu_box {
        width: 100%;
        background: #00a0e9;
        display: none;
      }
      .menu_h5_box {
        /deep/.el-dropdown-menu__item,
        .el-menu-item {
          padding: 0 20px;
        }
      }
      #banner {
        display: none;
      }
    }
    .content {
      width: 100%;
      box-sizing: border-box;
      padding: 30px 0;
      display: flex;
      justify-content: center;
      .view {
        width: 40%;
        margin: 0 10px;
        display: inline-flex;
        flex-direction: column;
        justify-content: space-between;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        cursor: pointer;
      }
      .vi_top {
        text-align: center;
        margin-top: 20px;
        .vi_top_name {
          font-size: 24px;
          color: #353535;
          font-weight: 700;
          letter-spacing: 1.6px;
        }
        .vi_top_text {
          font-size: 14px;
          color: #888;
          margin-top: 6px;
        }
      }
      .vi_down {
        width: 100%;
        height: 180px;
        margin-bottom: 0;
        overflow: hidden;
        position: relative;
        .vi_down_img {
          width: 160px;
          height: 140px;
          -webkit-transition: transform 0.2s;
          transition: transform 0.2s;
          position: absolute;
          bottom: 0;
          left: 0;
          will-change: transform;
        }
        .vi_down_img:hover {
          transform: translateY(-10px);
        }
      }
    }
    .contentTwo {
      background: #fff;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 48px 0;
      .view {
        width: 240px;
        height: 80px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        border-right: 1px dotted #eee;
        position: relative;
        .icon {
          width: 48px;
          height: 48px;
          position: absolute;
          top: 4px;
          left: auto;
          right: auto;
        }
        .name {
          font-size: 13px;
          color: #333;
        }
        .contenItem {
          font-size: 9px;
          color: #999;
          display: none;
        }
      }
    }
  }
}

.el-form--inline .el-form-item {
  margin-bottom: 0;
}
/deep/.el-alert__title {
  font-size: 17px;
  line-height: 20px;
  color: #ffffff;
}
.alert-title span {
  animation: scale 2s infinite;
}
@keyframes scale {
  0%,
  100% {
    transform: scale(1);
    color: #ffffff;
    font-size: 13px;
  }
  50% {
    transform: scale(1.5);
    color: #f8f85a;
    font-size: 16px;
  }
}

.scale-text {
  animation: scale 4s infinite;
}
.information {
  height: 40px;
}
/deep/.menu_item {
  padding-left: 20px;
  color: rgb(255, 255, 255);
  background-color: #00a0e9;
}
/deep/.menu_item_h5 {
  padding: 0 20px !important;
  color: rgb(255, 255, 255);
  background-color: #00a0e9;
}
.el-menu {
  border-right: solid 1px #00a0e9;
}
.el-menu--horizontal {
  flex-wrap: wrap;
}
.el-menu--horizontal > .el-menu-item.is-active {
  color: #ffffff !important;
  border-bottom: 2px solid #ffffff !important;
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  color: #00a0e9 !important;
}
/deep/.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
/deep/.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
/deep/.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: #00a0e9 !important;
}
/deep/.el-submenu .el-submenu__title:hover {
  background-color: #00a0e9 !important;
}
/deep/.el-submenu__title {
  color: #ffffff !important;
  background: #00a0e9;
}
/deep/.el-menu-item-group__title {
  background: #00a0e9;
}
/deep/.el-submenu__title i {
  color: #ffffff !important;
}
.el-carousel__item {
    transform: translateZ(0);
    will-change: transform;
}
</style>